export enum kategorienModel {
  SINGULAR = 'Kategorie',
  PLURAL = 'Kategorien',
  ROUTE = '/kategorien',
  ICON = 'mdi-bookmark',
  ITEM_KEY = 'kategorie',
  ITEM_KEY_UPDATE = 'kategorien'
}
